import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { QuoteProvider } from "@/context/QuoteContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingBar from "@/components/FloatingBar";
import QuoteModal from "@/components/QuoteModal";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Reviews from "@/pages/Reviews";
import ServiceArea from "@/pages/ServiceArea";
import Contact from "@/pages/Contact";
import Gallery from "@/pages/Gallery";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <QuoteProvider>
        <ScrollToTop />
        <Header />
        <main className="pb-14 md:pb-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/service-area" element={<ServiceArea />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <FloatingBar />
        <QuoteModal />
      </QuoteProvider>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
